
<template>

  <div :class="$store.state.onboard.obEntity === 'access' ? 'ob-main tilt-main' : 'ob-main'">
    <div class="dark-overlay" :style="{'background-color': $store.state.onboard.obEntity === 'access' ? 'rgba(0, 0, 0, 0.75)' : '#151920'}">
      <div class="ob-outer">
        <div class="ob-header">
          <div class="ob-img">
            <img :src="entity.img" />
          </div>
          <h3>{{clauses[entity.title]}}</h3>
          <a class="ob-back" @click="navBack()"><small>x</small></a>
        </div>
        <div class="ob-body" v-if="!summary">
          <prog-component></prog-component>
          <div class="ob-step" v-for="(step, index) in entity.steps" v-if="index === obStep">
            <h4 class="step-title" v-if="step.hover">{{clauses[step.title]}}
              <v-popover offset="15" trigger="hover" v-if="$store.state.user.tutorial">
                 <img  src="@/assets/hoverInfo.png"/>
                 <template slot="popover">
                   <hover-component :options="fullHover(step.hover)"></hover-component>
                 </template>
              </v-popover>
            </h4>
            <h4 v-else>{{clauses[step.title]}}</h4>
            <form class="ob-form" v-for="(subStep, subIndex) in step.subSteps" v-if="subIndex === obSubStep">
              <div class="filter-size" v-if="subStep.inputs.find(i => i.val === 'length')">
                <small>{{clauses.fSize}}</small>
                <div class="size-input-box">
                  <input class="ob-input size-input" v-model="obPacket.length" />
                  <label>{{clauses.len}}</label>
                </div>
                <p class="size-x">x</p>
                <div class="size-input-box">
                  <input class="ob-input size-input" v-model="obPacket.width" />
                  <label>{{clauses.wid}}</label>
                </div>
                <p class="size-x">x</p>
                <div class="size-input-box">
                  <input class="ob-input size-input" v-model="obPacket.depth" />
                  <label>{{clauses.dep}}</label>
                </div>
                <div class="ob-unit-toggle">
                  <div :class="`ob-unit-node${units === 'in' ? ' active-unit-node' : ''}`" @click="switchUnits('in')">
                    <h4>in</h4>
                  </div>
                  <div :class="`ob-unit-node${units === 'mm' ? ' active-unit-node' : ''}`" @click="switchUnits('mm')">
                    <h4>mm</h4>
                  </div>
                </div>
              </div>
              <div class="ob-input-box" v-for="input in subStep.inputs.filter(i => i.type === 'input')">
                <input class="ob-input" v-model="obPacket[input.val]" v-on:keyup.enter="enterProg" v-if="input.val !== 'floorName'" />
                <input class="ob-input" v-model="obPacket.floorName" v-on:keyup.enter="enterProg" v-else />
                <label class="ob-label">{{clauses[input.label]}}</label>
              </div>
              <div class="ob-input-box" v-for="input in subStep.inputs.filter(i => i.type === 'number')">
                <input class="ob-input" v-model="obPacket[input.val]" v-on:keyup.enter = "enterProg" type="number" oninput="validity.valid||(value='');"/>
                <label class="ob-label">{{clauses[input.label]}}</label>
              </div>
              <div class="ob-input-box ap-input-box" v-if="subStep.inputs[0].type === 'apid'">
                <div class="ap-internal">
                  <h4>AP</h4>
                  <input class="ob-input" v-model="obPacket[subStep.inputs[0].val]" type="number" @keypress="onlyNumber" />
                </div>
                <small class="located-under">{{clauses.locatedUnder}}</small>
              </div>
              <search-list-component
                v-for="searchList in containsSearchList(subStep)"
                :input="subStep.inputs.filter(i => i.type === 'searchList')[0]"
                v-on:setSearchedItem="setSearched($event, subStep)"
              >
              </search-list-component>
              <div class="ob-btns">
                <a class="land-btn ob-btn sec-btn" v-if="obStep > 0" @click="setStep(false)">{{clauses.back}}</a>
                <a class="land-btn ob-btn prim-btn" v-if="fulfilled() && !containsSearchList(subStep).length && !bldgCity()" @click="setStep(true)">{{clauses.next}}</a>
                <a class="land-btn ob-btn tre-btn" v-if="fulfilled() && bldgCity()" @click="validateBldgCity()">Validate</a>
              </div>
            </form>
          </div>
        </div>
        <div class="ob-body sum-body" style="height:100%;" v-else>
          <div class="search-outer">
            <h4>{{clauses.sum}}</h4>
            <div class="search-body" style="height:80%;">
              <div class="search-node summary-node" v-for="item in $store.getters.obProps()" @click="summaryNav(item.step, item.subStep)">
                <h3 class="search-header" style="">{{clauses[item.label].length < 12 ? clauses[item.label] : clauses[item.label].substring(0, 12) + '...'}}</h3>
                <h3 style="width:60%;margin-right:10px;overflow:hidden;">{{item.val}}</h3>
              </div>
            </div>
          </div>
          <div class="ob-btns">
            <a class="land-btn ob-btn prim-btn" @click="$store.dispatch('submitObRequest', $screen.breakpoint)">{{clauses.sub}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import { mapState } from 'vuex';

import Templates from '@/lib/obTemplates';
import Helper from '@/lib/langTemplates/HelperClauses';

import SearchList from './SearchList';
import Progress from './Progress';
import Hover from '../hover/Hover';

export default {

  data(){
    return {
      full: 0,
      summary: false,
      units: 'in'
    }
  },

  components: {
    'prog-component': Progress,
    'search-list-component': SearchList,
    'hover-component': Hover
  },

  computed: {
    entity(){
      return Templates[this.$store.state.onboard.obEntity];
    },
    obStep(){
      return this.$store.state.onboard.obStep;
    },
    obSubStep(){
      return this.$store.state.onboard.obSubStep;
    },
    obPacket(){
      return this.$store.state.onboard.obPacket;
    },
    clauses(){
      let lPref = this.$store.state.lang;
      let lang;
      switch (this.$store.state.onboard.obEntity) {
        case 'access':
          lang = 'RequestAccessTemplate';
        break;
        case 'bldg':
          lang = 'OnboardBuildingTemplate';
        break;
        case 'room':
          lang = 'OnboardRoomTemplate';
        break;
        case 'user':
          lang = 'OnboardUserTemplate';
        break;
      }
      const Lang = require(`@/lib/langTemplates/${lang}`);
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    }
  },

  methods: {

    onlyNumber ($event) {
     let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
     if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
     }
   },

    navBack(){
      let route;
      switch (this.$store.state.onboard.obEntity) {
        case 'access':
          route = '/';
        break;
        case 'bldg':
          route = '/organization';
        break;
        case 'room':
          route = this.$store.state.floorIndex && parseInt(this.$store.state.floorIndex)
            ? (this.$screen.breakpoint === 'sm' ? `/floor/${this.$store.state.floorIndex}` : `/heatmap/${this.$store.state.floorIndex}`)
            : `/building/${this.$store.state.buildingId}`;
        break;
        case 'user':
          route = 'organization';
        break;
      }
      this.$router.push({path: route});
    },

    fulfilled(){
      let approve = false;
      const self = this;
      let inputs = self.entity.steps[self.obStep].subSteps[self.obSubStep].inputs;
      if (inputs.filter(i => !i.optional).every(i => self.obPacket[i.val] && self.obPacket[i.val].length)) {
        if (!inputs.filter(i => i.type === 'apid').length || inputs.every(i => self.obPacket[i.val].length >= 7)) {
          return this.findOutliers(inputs);
        }
      }
    },
    findOutliers(inputs){
      if (inputs.find(i => i.val === 'email')){
        if (this.obPacket[inputs.find(i => i.val === 'email').val].includes('@')) {
          return true;
        }
      }
      return true;
    },

    setStep(inc){
      let inputs = this.entity.steps[this.obStep].subSteps;
      if (!!inc) {
        if (this.obStep === this.entity.steps.length - 1 && this.obSubStep === inputs.length - 1) {
          this.summary = true;
        } else {
          if ((this.$store.state.onboard.obEntity === 'bldg'
                && this.entity.steps[this.obStep].subSteps[this.obSubStep].inputs.find(i => i.val === 'zipCode'))
              || (this.$store.state.onboard.obEntity === 'room' && this.obStep === 0)
          ) {
            this.validateEntity()
          } else {
            this.obSubStep < inputs.length -1 ? this.$store.dispatch('setObSubStep', this.obSubStep + 1) : this.$store.dispatch('setObStep', this.obStep + 1);
          }
        }
      } else {
        this.obSubStep > 1 ? this.$store.dispatch('setObSubStep', this.obSubStep - 1) : this.$store.dispatch('setObStep', this.obStep - 1);
      }
    },

    async validateEntity(){
      const packet = this.obPacket;
      const apid = Object.keys(packet).includes('apid');
      const toValidate = apid
        ? {}
        : {
          city: packet.city,
          country: packet.country,
          zipCode: packet.zipCode
        };
      this.$store.dispatch('loadingOn');
      try {
        await this.$store.dispatch(apid ? 'validateAPID' : 'validateLocation', apid ? packet.apid : toValidate);
        this.$store.dispatch('setObStep', this.obStep + 1);
      } catch(err) {
        const locationErr = {
          type: 'err',
          title: Helper.clauses.locNotFound[`${this.$store.state.lang}Title`],
          body: Helper.clauses.locNotFound[this.$store.state.lang]
        };
        const apidErr = {
          type: 'err',
          title: Helper.clauses.devNotFound[`${this.$store.state.lang}Title`],
          body: Helper.clauses.devNotFound[this.$store.state.lang]
        };
        this.$store.dispatch('initNotif', apid ? apidErr : locationErr);
      }
      this.$store.dispatch('loadingOff');
    },

    setSearched(event, subStep){
      let val = subStep.inputs.filter(i => i.type === 'searchList')[0].val;
      this.$store.dispatch('setCountryCities', event);
      this.$store.dispatch('setObSearchResult', {prop: val, val: event});
      this.setStep(true);
    },

    summaryNav(step, subStep){
      this.$store.dispatch('setObStep', step);
      this.$store.dispatch('setObSubStep', subStep);
      this.summary = false;
    },

    containsSearchList(subStep){
      return subStep.inputs.filter(i => i.type === 'searchList')
         ? subStep.inputs.filter(i => i.type === 'searchList')
         : [];
    },

    enterProg(){
      if (this.fulfilled()) this.setStep(true);
    },

    bldgCity(){
      let step = this.entity.steps[this.obStep];
      let subStep = step.subSteps[this.obSubStep];
      let city = subStep.inputs.find(i => i.val === 'city');
      return city != undefined && this.$store.state.onboard.obEntity === 'bldg';
    },

    switchUnits(units){
      this.units = units;
      this.$store.dispatch('setObUnits', units);
    },

    fullHover(hover){
      return hover;
    },

    hoverVid(evt){
      setTimeout(() => {
        this.$store.dispatch(
          'setHoverTempFromComponent',
          !this.$store.state.hover.temp.title.length
          ? {
            x: evt.pageX,
            y: evt.pageY,
            type: 'vid',
            title: 'Installing an AirPulse',
            src: "https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstleyVEVO"
          }
          : {}
        )
      }, this.$store.state.hover.temp.title.length ? 0 : 1000);
    }

  },

  mounted(){
    this.$store.dispatch('clearObPacket');
    if (Math.round(Date.now()/1000) >= this.$store.state.sessionEnd && this.$store.state.onboard.obEntity !== 'access') {
      this.$store.dispatch('logoutNotif');
      this.$router.push({path: '/'});
    }
    this.$store.dispatch('setObUnits', 'in');
  },

}

</script>

<style>

.ob-step {
  width: 100%;
  height: calc(100% - 58px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.ob-form {
  width: 90%;
  height: 85%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.ob-input-box {
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 10px;
}

.search-outer {
  width: 100%;
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-x: hidden;
  overflow-y: scroll;
  margin-top: 20px;
}

.search-body {
  width: 100%;
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  overflow-x: hidden;
  overflow-y: scroll;
}

.search-node {
  width: 300px;
  min-height: 55px;
  max-height: 55px;
  margin: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid #262d37;
  padding: 6px;
  border-radius: 3px;
  cursor: pointer;
}

.search-node:hover {
  background-color: #262d37;
}

.search-node h3 {
  font-size: 0.85em;
  font-weight: lighter;
}

.flag-img {
  height: 30px;
  width: auto;
}

.summary-node {
  padding: 0px;
  border: 1px solid rgb(0, 153, 191);
  overflow: hidden;
}

.search-header {
  width: 40%;
  min-height: 55px;
  max-height: 55px;
  background-color: rgb(0, 153, 191);
  display: flex;
  justify-content: center;
  align-items: center;
}

.ap-input-box {
  height: auto;
}

.ap-internal {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ap-internal input {
  width: 230px;
  font-size: 2em;
  text-align: center;
}

.ap-internal h4 {
  color: rgb(0, 153, 191);
  font-size: 1.5em;
  font-weight: lighter;
}

.ap-input-box small {
  width: 75%;
  padding: 8px;
  color: gray;
  background-color: rgba(0, 0, 0, 0.2);
}

.ap-input-box input {
  margin-left: 5px;
}

.filter-size {
  width: 90%;
  min-width: 300px;
  height: 130px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid gray;
  position: relative;
  margin-top: 20px;
  margin-bottom: 20px;
}

.size-input-box {
  width: 33%;
  height: 95%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 5px;
}

.size-input-box input {
  width: 80%;
  text-align: center;
  color: rgb(0, 153, 191);
  position: relative;
}

.filter-size small {
  position: absolute;
  top: -.7em;
  padding: 2px;
  background-color: #3f3f41;
}

.size-x {
  margin-bottom: 5px;
}

.ob-unit-toggle {
  width: 200px;
  height: 30px;
  border: 1px solid rgb(0, 153, 191);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: -15px;
  left: calc(50% - 100px);
  background-color: #3f3f41;
}

.ob-unit-node {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.active-unit-node {
  background-color: rgb(0, 153, 191);
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.sum-body {
  justify-content: center;
  overflow: hidden;
}

.located-under {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.located-under img {
  height: 20px;
}

.step-title {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0px;
  margin-top: 10px;
}

.step-title img {
  height: 17.5px;
  margin-left: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/onboard/Onboard.vue